import axios from 'axios';
import API from '../config/api';
import { auth } from '../firebaseConfig';
import { canSyncDoctor, profileOfflineEnabled } from './config';

const grantKey = (uid, doctorId) => `dashboard-offline-access:${JSON.stringify([uid, doctorId])}`;
const checked = new Map();
let pending;

export function activeOfflineDoctor() {
  const doctorId = localStorage.getItem('doctorId') || '';
  const uid = auth.currentUser?.uid;
  if (!uid || !doctorId) return '';
  try {
    const grant = JSON.parse(localStorage.getItem(grantKey(uid, doctorId)) || 'null');
    return grant?.actorUid === uid && grant?.doctorId === doctorId && grant?.enabled === true ? doctorId : '';
  } catch { return ''; }
}

export async function ensureOfflineAccess() {
  const user = auth.currentUser;
  const doctorId = localStorage.getItem('doctorId');
  if (!profileOfflineEnabled || !user || !navigator.onLine || !canSyncDoctor(doctorId)) return;
  const key = grantKey(user.uid, doctorId);
  if (pending || Date.now() - (checked.get(key) || 0) < 300000) return;
  checked.set(key, Date.now());
  pending = (async () => {
    try {
      const token = await user.getIdToken();
      const { data } = await axios.post(`${API.BASE_URL}/api/offline/access`, { doctorId }, {
        headers: { Authorization: `Bearer ${token}` }, timeout: 15000,
      });
      if (auth.currentUser?.uid !== user.uid || localStorage.getItem('doctorId') !== doctorId) return;
      if (data.actorUid !== user.uid || data.doctorId !== doctorId || data.enabled !== true) throw new Error('Invalid offline access response');
      const previous = localStorage.getItem(key);
      localStorage.setItem(key, JSON.stringify(data));
      if (previous !== JSON.stringify(data)) window.dispatchEvent(new Event('doctorIdChanged'));
    } catch (error) {
      if ([401, 403, 503].includes(error.response?.status) && error.response?.data?.code !== 'OFFLINE_ACCESS_UNAVAILABLE') {
        localStorage.removeItem(key);
        window.dispatchEvent(new Event('doctorIdChanged'));
      }
      throw error;
    } finally { pending = null; }
  })();
  return pending;
}
